import { useEffect, useState } from 'react';
import { brandName, navLinks } from '@/mocks/clearing';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-all duration-300 ${
        scrolled
          ? 'border-background-200/80 bg-background-50/90 backdrop-blur-md'
          : 'border-transparent bg-background-50/60 backdrop-blur-sm'
      }`}
    >
      <div className="flex h-[68px] w-full items-center justify-between gap-6 px-4 md:px-8 lg:px-12">
        <a href="#top" className="group flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50 dark:text-foreground-950">
            黑
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
              {brandName}
            </span>
            <span className="mt-1 font-label text-[10px] tracking-[0.22em] text-foreground-500">
              CLARIFY · REVERSE · TRUTH
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap font-label text-[13px] text-foreground-700 transition-colors duration-200 hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <div className="flex h-9 w-48 items-center gap-2 rounded-md border border-background-300/70 bg-background-100/80 px-3 lg:w-56">
            <i className="ri-search-line text-sm text-foreground-400" />
            <input
              type="text"
              placeholder="搜索传闻 / 当事人 / 时间线"
              className="w-full bg-transparent font-label text-[13px] text-foreground-800 placeholder:text-foreground-400 focus:outline-none"
            />
          </div>
          <a
            href="#ranking"
            className="flex h-9 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 font-label text-[13px] font-medium text-background-50 transition-colors duration-200 dark:text-foreground-950 hover:bg-primary-600"
          >
            <i className="ri-fire-line" />
            进入热度榜
          </a>
        </div>

        <button
          type="button"
          aria-label="打开导航菜单"
          onClick={() => setMenuOpen((prev) => !prev)}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300/70 text-foreground-800 md:hidden"
        >
          <i className={menuOpen ? 'ri-close-line text-lg' : 'ri-menu-line text-lg'} />
        </button>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-200/80 bg-background-50 px-4 pb-6 pt-4 md:hidden">
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="flex items-center justify-between rounded-md px-3 py-3 font-label text-sm text-foreground-800 transition-colors duration-200 hover:bg-background-100"
              >
                {link.label}
                <i className="ri-arrow-right-s-line text-foreground-400" />
              </a>
            ))}
          </nav>
          <div className="mt-4 flex h-11 items-center gap-2 rounded-md border border-background-300/70 bg-background-100 px-3">
            <i className="ri-search-line text-sm text-foreground-400" />
            <input
              type="text"
              placeholder="搜索传闻 / 当事人 / 时间线"
              className="w-full bg-transparent font-label text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none"
            />
          </div>
        </div>
      ) : null}
    </header>
  );
}